import { Endianness } from './Endianness';

export enum Status {
  IN_SYSTEM = 'in_system',
  LAUNCHED = 'launched',
  SOFT_LAUNCHED = 'soft_launched',
}

export type TextDirectionality = 'tb-lr' | 'tb-rl';

export type Market = {
  endianness: Endianness;
  language: string;
  language_fallbacks: string[];
  market: string;
  preferred_locale: string;
  status: Status;
  text_directionality: TextDirectionality;
};
